import { AutomationSetting, AutomationSettingValues } from '@maximizer/actions/domain';
import { TextParam, TranslatedText } from '../models/ai-hub.models';
import { isKnownSetting } from './preference-values';
import { sendAtToDate } from './send-at';

export const PREFERENCE_BASE = 'aiHub.preferences.automations';

export interface PreferenceSummaryInput {
  automationId: string;
  settings: readonly AutomationSetting[];
  values: AutomationSettingValues;
  formatTime: (date: Date) => string;
}

export function preferenceSummary({ automationId, settings, values, formatTime }: PreferenceSummaryInput): TranslatedText {
  const base = `${PREFERENCE_BASE}.${automationId}`;
  const params: Record<string, TextParam> = Object.fromEntries(
    settings.filter(isKnownSetting).map((setting) => {
      const value = values[setting.name];
      const param: TextParam =
        setting.type === 'time'
          ? formatTime(sendAtToDate(value))
          : {
              key: `${base}.summaryValues.${setting.name}.${value}`,
              fallback: {
                key: `${base}.settings.${setting.name}.options.${value}`,
                fallback: setting.options.find((option) => option.value === value)?.text ?? value,
              },
            };
      return [setting.name, param];
    }),
  );

  return { key: `${base}.summary`, params, fallback: { key: 'aiHub.access.onInAccount' } };
}
